import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Layout } from './components/layout/Layout';
import { Header } from './components/home/Header';
import { FeatureSection } from './components/home/FeatureSection';
import { WaitlistSection } from './components/home/WaitlistSection';
import { ToastProvider } from './components/providers/ToastProvider';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminLogin } from './pages/AdminLogin';
import { AdminRoute } from './components/AdminRoute';

function HomePage() {
  const scrollToForm = () => {
    document.getElementById('waitlist-section')?.scrollIntoView({ behavior: 'smooth' });
  };

  const brideFeatures = [
    '🌸 A transparent vendor comparison tool',
    '💍 Upfront pricing from trusted professionals',
    '🎁 Access to exclusive planning resources'
  ];

  const vendorFeatures = [
    '📈 Increased visibility in a growing market',
    '💡 Tools to manage and promote your services',
    '🤝 Direct connections with engaged clients'
  ];

  return (
    <Layout>
      <Header />
      <div className="max-w-6xl mx-auto px-4 py-12">
        <div className="grid md:grid-cols-2 gap-12">
          <FeatureSection
            title="For Brides"
            description="Say goodbye to wedding stress! WeddingWalliyan is designed to make your planning effortless with:"
            features={brideFeatures}
            ctaText="Join the Waitlist Now"
            onCtaClick={scrollToForm}
          />
          <FeatureSection
            title="For Vendors"
            description="Showcase your business to eager couples! As a WeddingWalliyan vendor, you'll benefit from:"
            features={vendorFeatures}
            ctaText="Sign Up to Partner with Us"
            onCtaClick={scrollToForm}
          />
        </div>
        <WaitlistSection />
      </div>
    </Layout>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route
            path="/admin/dashboard"
            element={
              <AdminRoute>
                <AdminDashboard />
              </AdminRoute>
            }
          />
        </Routes>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;